import { Divider, Form, Spin } from "antd";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import svg89 from "../../../../assets/svg/svg89.svg";
import svg88 from "../../../../assets/svg/svg88.svg";
import svg90 from "../../../../assets/svg/svg90.svg";
import { cashConverter } from "../../../../utils";
import PathwayProgress from "./PathwayProgress";
import ImpactAnalysisPieChart from "./ImpactAnalysisPieChart";

const InfoCard = ({ bgColor, items }) => (
  <div
    className={`mt-[1rem] ${bgColor} flex lg:flex-row flex-col lg:items-center lg:gap-0 gap-5 lg:justify-between lg:p-[1.5rem] p-[1rem] rounded-[1rem]`}
  >
    {items.map((item, idx) => (
      <div key={idx} className="flex flex-col">
        {item.labels?.map((label, i) => (
          <div
            key={i}
            className={`${item.textColor} text-[${
              item.textSize || ".75rem"
            }] font-sora font-[400] ${item.leading || ""} ${
              i > 0 ? "mt-[.5rem]" : ""
            }`}
          >
            {label}
          </div>
        ))}
        {item.values?.map((value, i) => (
          <div
            key={i}
            className={`${item.valueColor} ${
              i === 0 && !item.labels
                ? "mt-[1rem]"
                : i > 0
                ? "mt-[.5rem]"
                : "mt-[1rem]"
            } text-[${item.valueSize || "1rem"}] font-[600] ${
              item.leading || ""
            }`}
          >
            {value}
          </div>
        ))}
      </div>
    ))}
  </div>
);

function SummaryList({ handleNext, handleBack, handleReset }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { activeObj } = useSelector((state) => state.obj);
  const onFinish = async (data) => {
    await handleNext();
  };

  return (
    <div>
      <div className="flex flex-col lg:px-[5rem] px-3">
        <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[400] leading-[1.5rem]   w-full   items-center text-center justify-center">
          Investment Summary
        </div>

        <div className="text-[#1A1A1A] font-sora text-[.875rem] font-[400]    mt-[1rem] items-center text-center justify-center">
          Your NISIP Investment Analysis Results
        </div>

        <div className="lg:mt-[2.5rem] mt-[1rem] lg:p-[2.5rem] p-3 rounded-[1rem] bg-white">
          <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[600] leading-[1.5rem]">
            Investor Summary
          </div>

          <InfoCard
            bgColor="bg-[#F1F3F5]"
            items={[
              {
                labels: ["Investment Amount:"],
                values: [cashConverter(activeObj?.invAmount)],
                textColor: "text-[#1A1A1A]",
                valueColor: "text-[#0092CC]",
              },
              {
                labels: ["Pathway"],
                values: ["Expanded FLID Analysis"],
                textColor: "text-[#1A1A1A]",
                valueColor: "text-[#0092CC]",
              },
            ]}
          />

          <InfoCard
            bgColor="bg-white"
            items={[
              {
                labels: ["Investment Type :", "Cost per Acre :"],
                textColor: "text-[#424242]",
                textSize: ".875rem",
                leading: "leading-[1.5rem]",
              },
              {
                values: ["Partnership Development", "KSh 1,337,500.00"],
                valueColor: "text-[#424242]",
                valueSize: ".875rem",
                leading: "leading-[1.5rem]",
              },
            ]}
          />

          <div className="lg:mt-[3.75rem] mt-[1rem] grid lg:grid-cols-2 grid-cols-1 w-full">
            <ImpactAnalysisPieChart />
            <PathwayProgress />
          </div>
        </div>

        <div className="sticky lg:mb-[6.25rem] mb-[3rem] left-0 w-full lg:mt-[3.75rem] mt-[1rem] ">
       
          <Divider />
          <div className="flex lg:flex-row flex-col justify-between lg:items-center mt-[1rem] gap-x-[1.25rem]">
            <button
              onClick={handleBack}
              type="button"
              key="back"
              className="flex items-center gap-[1rem]"
            >
              <img src={svg88} alt="svg88" /> Previous
            </button>

            <div className="flex lg:flex-row flex-col justify-end lg:items-center gap-[1.25rem]">
              <button
                disabled={saving}
                type="button"
                onClick={handleReset}
                className="cstm-btn-2 !w-fit"
              >
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    <img src={svg89} alt="svg89" /> Start New Calculation
                  </>
                )}
              </button>

              <button
                disabled={saving}
                type="button"
                className="cstm-btn !w-fit"
              >
                {saving ? (
                  <Spin />
                ) : (
                  <>
                  <img src={svg90} alt="svg90" />   Download pdf Estimates
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummaryList;
